<template>
  <div class="card flex-fill">
    <div class="card-header">
      <h5 class="card-title mb-0">{{ title }}</h5>
    </div>
    <table class="table table-hover my-0">
      <thead>
      <tr v-if="type === 'members'">
        <th class="d-xl-table-cell">First Name</th>
        <th class="d-xl-table-cell">Last Name</th>
        <th class="d-xl-table-cell">Email</th>
        <th class="d-md-table-cell">Phone Number</th>
        <th class="d-md-table-cell">Profession</th>
        <th class="d-md-table-cell">Looking For</th>
        <th class="d-md-table-cell" v-if="1===0">Paths</th>
      </tr>
      <tr v-if="type === 'businesses'">
        <th class="d-xl-table-cell">First Name</th>
        <th class="d-xl-table-cell">Last Name</th>
        <th class="d-xl-table-cell">Email</th>
        <th class="d-md-table-cell">Business Name</th>
        <th class="d-md-table-cell">Position</th>
        <th class="d-md-table-cell">Address</th>
        <th class="d-md-table-cell">Website</th>
        <th class="d-md-table-cell">Looking For</th>
        <th class="d-md-table-cell">Entity Application Form</th>
      </tr>
      <tr v-if="type === 'entities'">
        <th class="d-xl-table-cell">Email</th>
        <th class="d-md-table-cell">Emirate</th>
        <th class="d-md-table-cell">School name</th>
        <th class="d-md-table-cell">Training method</th>
        <th class="d-md-table-cell">Number of programs</th>
        <th class="d-md-table-cell">Number of users per path</th>
        <th class="d-md-table-cell">Number of supervisors</th>
        <th class="d-md-table-cell">Request of creating playlists</th>
        <th class="d-md-table-cell">Request pre registration</th>
        <th class="d-md-table-cell">Student enrolment method</th>
        <th class="d-md-table-cell">Request entity interview</th>
        <th class="d-md-table-cell">Request office hours</th>
        <th class="d-md-table-cell">Passing methods</th>
        <th class="d-md-table-cell">Is Accepted</th>
      </tr>
      <tr v-if="type === 'contacts'">
        <th class="d-xl-table-cell">Contact Name</th>
        <th class="d-xl-table-cell">Contact Number</th>
        <th class="d-xl-table-cell">Email</th>
        <th class="d-md-table-cell">Business Name</th>
      </tr>
      <tr v-if="type === 'newsletters'">
        <th class="d-xl-table-cell">Email</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="d in data" :key="d.id">
        <td class="d-xl-table-cell" v-if="d.contactName">{{ d.contactName }}</td>
        <td class="d-xl-table-cell" v-if="d.firstName">{{ d.firstName }}</td>
        <td class="d-xl-table-cell" v-if="d.lastName">{{ d.lastName }}</td>
        <td class="d-xl-table-cell" v-if="d.familyName">{{ d.familyName }}</td>
        <td class="d-xl-table-cell" v-if="d.email">{{ d.email }}</td>
        <td class="d-xl-table-cell" v-if="d.contactNumber">{{ d.contactNumber }}</td>
        <td class="d-xl-table-cell" v-if="d.phoneNumber">{{ d.phoneNumber }}</td>
        <td class="d-md-table-cell" v-if="d.profession">{{ d.profession }}</td>
        <td class="d-md-table-cell" v-if="d.businessName">{{ d.businessName }}</td>
        <td class="d-md-table-cell" v-if="d.position">{{ d.position }}</td>
        <td class="d-md-table-cell" v-if="d.address">{{ d.address }}</td>
        <td class="d-md-table-cell" v-if="d.website"><a :href="d.website" target="_blank">{{ d.website }}</a></td>
        <td class="d-md-table-cell" v-if="d.lookingFor">{{ d.lookingFor }}</td>
        <td class="d-md-table-cell" v-if="type === 'businesses'">
          <div v-if="d.isEmailSent" class="badge badge bg-success">Email Sent</div>
          <button v-else @click.prevent="sendEmail(d.id)" class="btn btn-sm btn-primary">Send Entity Application Email
          </button>
        </td>
        <td class="d-md-table-cell" v-if="d.emirate">{{ d.emirate }}</td>
        <td class="d-md-table-cell" v-if="d.schoolName">{{ d.schoolName }}</td>
        <td class="d-md-table-cell" v-if="d.trainingMethod">{{ d.trainingMethod }}</td>
        <td class="d-md-table-cell" v-if="d.numberOfPrograms">{{ d.numberOfPrograms }}</td>
        <td class="d-md-table-cell" v-if="d.numberOfUsersPerPath">{{ d.numberOfUsersPerPath }}</td>
        <td class="d-md-table-cell" v-if="d.numberOfSupervisors">{{ d.numberOfSupervisors }}</td>
        <td class="d-md-table-cell" v-if="d.requestOfCreatingPlaylists">{{ d.requestOfCreatingPlaylists }}</td>
        <td class="d-md-table-cell" v-if="d.requestPreRegistration">{{ d.requestPreRegistration }}</td>
        <td class="d-md-table-cell" v-if="d.studentEnrolmentMethod">{{ d.studentEnrolmentMethod }}</td>
        <td class="d-md-table-cell" v-if="d.requestEntityInterview">{{ d.requestEntityInterview }}</td>
        <td class="d-md-table-cell" v-if="d.requestOfficeHours">{{ d.requestOfficeHours }}</td>
        <td class="d-md-table-cell" v-if="d.passingMethods">
          <ul>
            <li v-for="(a, id) in d.passingMethods" :key="id">{{ a }}</li>
          </ul>
        </td>
        <td class="d-md-table-cell" v-if="type === 'entities'">
          <a @click.prevent="setIsAccepted(d.id)" class="badge" :class="[d.isAccepted ? 'bg-success' : 'bg-warning']">
            {{ d.isAccepted ? 'YES' : 'NO' }}
          </a>
        </td>
        <td class="d-md-table-cell" v-if="type === 'members' && 1===0">
          <ul v-if="d.paths && d.paths.length">
            <li v-for="path in d.paths" :key="path.id">{{ path.name }} Level: {{ path.level }}</li>
          </ul>
          <div v-else>
            <button class="btn btn-sm btn-primary" @click.prevent="setLearningPaths(d.id)">Set Learning Paths</button>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import AdminService from "@/services/admin.service";

export default {
  props: ["title", "data", "type"],
  emits: ["showAllPaths", "selectedMember"],
  methods: {
    setLearningPaths(id) {
      this.$emit("showAllPaths", true);
      this.$emit("selectedMember", id);
    },
    sendEmail(id) {
      AdminService.sendEntityApplication(id);
      this.data.map(d => {
        if (d.id === id) {
          d.isEmailSent = true;
        }
      })
    },
    setIsAccepted(id) {
      AdminService.setIsAccepted(id);
      this.data.map(d => {
        if (d.id === id) {
          d.isAccepted = !d.isAccepted;
        }
      })
    }
  }
}
</script>
